import {
    Message,
    MessageBox
} from 'element-ui'
import Vue from 'vue'
import {
    printRecordAdd
} from "@/service/printApi.js";
import Store from '@/store'
import http from "@/service/http";
var bytesPerPiece = 1024 * 4; //分包大小
var filesize = 0; //超长数据总大小
var totalPieces = 0; //总分包数
var sendPieces = 0; //当前正在发送的分包
var start = 0;
var end;
var sendbytes;
var userDataFlag = false

var websock = null;
// var global_callback = null;
// var serverPort = '5000';	//webSocket连接端口
var soctetUrl = '127.0.0.1:31501/FServer'

var printArr = [] // 队列数组
var printArrLength = 0
var printType = '' // 打印方式
var printReportMod = '' // 指令码
var printIsShow = ''
var index = 0
var timer = ""
var isPrint = false
var manualReconnect = false // 是否为用户点击「重新连接」


function getWebIP() {
    var curIP = window.location.hostname;
    return curIP;
}

function initWebSocket() { //初始化weosocket
    //ws地址
    var wsuri = "ws://" + soctetUrl;
    sessionStorage.removeItem('isConnect')
    websock = new WebSocket(wsuri);
    websock.onmessage = function (e) {
        websocketonmessage(e);
    }
    websock.onclose = function (e) {
        index++
        if (index == 2) {
            websocketclose(e);
        } else {
            websock = new WebSocket(wsuri);
        }
    }
    websock.onopen = function () {
        websocketOpen();
    }

    // 连接发生错误的回调方法
    websock.onerror = function (e) {
        console.log("WebSocket连接发生错误");
        websocketclose(e);
    }
}

// 实际调用的方法
function sendSock(agentData, callback) {
    // console.log(agentData)
    global_callback = callback;
    if (websock.readyState === websock.OPEN) {
        //若是ws开启状态
        websocketsend(agentData)
    } else if (websock.readyState === websock.CONNECTING) {
        // 若是 正在开启状态，则等待1s后重新调用
        setTimeout(function () {
            sendSock(agentData, callback);
        }, 1000);
    } else {
        // 若未开启 ，则等待1s后重新调用
        setTimeout(function () {
            sendSock(agentData, callback);
        }, 1000);
    }
}

function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }

        } catch (e) {
            return false;
        }
    }
}
var orderId = ''
//数据接收
function websocketonmessage(e) {
    if (isJSON(e.data)) {
        var obj = JSON.parse(e.data);
        console.log('打印返回数据', obj)

        if (obj.message == 'save') {
            console.log(JSON.parse(obj.result))
            let res = JSON.parse(obj.result)
            if (res.reportkey == Vue.prototype.$printReportKey) {
                Vue.prototype.$printReportMod = res.reportmod
                console.log(Vue.prototype.$printReportMod)
            }
        }
        if (obj.status == '101' && obj.message == 'addprintcount') {

            var token = sessionStorage.getItem("token");
            let params = JSON.parse(obj.result)
            params.printName = params.reportname
            params.printId = params.reportkey
            params.businessId = params.businessid
            if (sessionStorage.getItem("businessId")) {
                params.businessId = sessionStorage.getItem("businessId")
            }
            if (!isPrint) {
                printRecordAdd(params, token).then((res) => {
                    if (res.status === 200) { }
                });
            }
            return
        }
        if (obj.status == 200 && obj.message == '打印完成') {
            if (printArr.length > 0) {
                Store.state.selectobj = ""
                var arr = printArr.shift()
                console.log(arr, "测试");
                Store.state.selectobj = arr.list
            }
            console.log(printArr,"测试");
            
            if (printArr.length > 0) {
                if (printArr.findIndex(item => item.tableName == 'detail') == -1 || printArr.findIndex(item => Object.hasOwn(item, 'list')) != -1) {
                    dosend([printArr[0]], printReportMod, printType, printIsShow, printNameNew, printCountNew, previewprintIdNew)
                }

            }
            if (sessionStorage.getItem("contractIds")) {
                http.addcontractsign({
                    ids: JSON.parse(sessionStorage.getItem("contractIds"))
                })
            }
            console.log('printArr', printArr)
            console.log('总共' + printArrLength + '条数据', '已打印' + (printArrLength - printArr.length) + '条数据', '剩余' + printArr.length + '条数据')
        }
    }
}
//数据发送
function websocketsend(agentData) {
    try {
        websock.send(JSON.stringify(agentData));
    } catch (error) {
        initWebSocket();
    }
}

//关闭
function websocketclose(e) {
    console.log("connection closed (" + e.code + ")");
    console.log("断开连接");
    sessionStorage.removeItem('isConnect')
    if (manualReconnect) {
        manualReconnect = false
        Message.error('打印服务连接失败，请检查客户端是否已启动')
    }
}

function websocketOpen(e) {
    console.log("连接成功");
    sessionStorage.setItem('isConnect', 1)
    if (manualReconnect) {
        manualReconnect = false
        Message.success('打印服务连接成功')
    }
}

function previewReport(userData, reportmod, type, printName, printCount, previewprintId, isAll = false, flag, isPrint) {
    isPrint = isPrint ? true : false
    userDataFlag = flag
    console.log(userData, reportmod, type, printName, printCount, previewprintId, isAll = false, flag);
    var isShow = false
    if (type == 'preview') {
        isShow = true
    } else if (type == 'print') {
        isShow = false
    }
    // if (userData[0].print) {
    // console.log(userData[0].print, reportmod, type, isShow, printName, printCount);
    if (type == 'preview') {
        if (isAll) {
            dosend([userData[0]], reportmod, type, isShow, printName, printCount, previewprintId)
        } else {

            dosend(userData, reportmod, type, isShow, printName, printCount, previewprintId)
        }
        return
    }
    printArr = JSON.parse(JSON.stringify(userData))
    printArrLength = userData.length

    // userData = userData[0].print
    // }
    printType = type
    printReportMod = reportmod
    printIsShow = isShow

    // console.log( printArr);
    // console.log('printArrLength', printArrLength)
    // console.log('printType', printType)
    // console.log('printIsShow', printIsShow)
    // console.log(isAll);
    if (isAll) {
        dosend([printArr[0]], reportmod, type, isShow, printName, printCount, previewprintId)
    } else {
        dosend(printArr, reportmod, type, isShow, printName, printCount, previewprintId)
    }
}

function time() {
    var time = Math.round(new Date() / 1000);
    return time;
}
var printNameNew = ''
var printCountNew = ''
var previewprintIdNew = ''
var printId = ''

function dosend(userData, reportmod, type, isShow, printName, printCount, previewprintId) {
    var printInfo = JSON.parse(sessionStorage.getItem('printInfo'))
    printNameNew = printName
    printCountNew = printCount
    previewprintIdNew = previewprintId
    // printId = time()
    console.log(userData, type)
    var jomsg = {
        "scheme": "print",
        "data": {
            "route": type,
            "param": {
                "reportkey": previewprintId, //方案ID
                "reportname": printName, //方案名称
                "reportmod": reportmod, //打印模板字符串
                "variables": { //自定义参数
                    opmName: printInfo.opmName,
                    // "机构名称": "1",
                    // "登录人": "2",
                    // "va3": 3,
                    printCount: printCount,
                    address: printInfo.address,
                    contact: printInfo.contact,
                    phone: printInfo.phone,
                    unit: printInfo.unit,
                },
                "ShowPrintDialog": isShow, //是否弹出打印框
                "PrintCopys": 1, //打印次数
                "userdata": userDataFlag ? userData[0].list : userData
            }
        }
    }
    console.log('发送的数据', jomsg)
    websocketsend(jomsg)
}
function designReport(userData, reportmod, printName) {
    var printInfo = JSON.parse(sessionStorage.getItem('printInfo'))
    const printId = Vue.prototype.$printReportKey
    var jomsg = {
        "scheme": "print",
        "data": {
            "route": "design",
            "param": {
                "reportkey": printId,//方案ID
                "reportname": printName, //方案名称
                "reportmod": reportmod, //打印模板字符串
                "variables": { //自定义参数
                    opmName: printInfo.opmName || '',
                    address: printInfo.address || '',
                    contact: printInfo.contact || '',
                    phone: printInfo.phone || '',
                    unit: printInfo.unit || '',
                    printCount: '0'
                },
                "ShowPrintDialog": "false", //是否弹出打印框
                "PrintCopys": 1, //打印次数
                "userdata": userData
            }
        }
    }
    websocketsend(jomsg)
}

function printExeMsg() {
    if (!sessionStorage.getItem('isConnect')) {
        MessageBox.confirm(
            '打印服务未连接，可尝试重新连接，或下载客户端程序',
            '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '重新连接',
            cancelButtonText: '去下载',
            type: 'warning'
        }
        ).then(() => {
            index = 0
            manualReconnect = true
            initWebSocket()
        }).catch((action) => {
            if (action === 'cancel') {
                window.location.href = sessionStorage.getItem('downUrl')
            }
        })
        return false
    }
}

initWebSocket();

export { sendSock, designReport, previewReport, printExeMsg }